(function () {
  var root = document.getElementById("lvq");
  if (!root) { return; }
  var MAP = {
    face: {
      dry: ["hydrating-toner","hydrating-serum","moisturising-day-cream"],
      dull: ["vitamin-c-serum","radiant-glow-facial-wash","targeted-dark-spot-care-1-kojic-acid","hydrating-toner"],
      blemish: ["blemish-purifying-face-wash","retinol-alternative-serum","hydrating-toner"],
      lines: ["peptide-anti-aging-serum","retinol-alternative-serum","moisturising-day-cream"],
      sensitive: ["sensitive-skin-oil-to-milk-cleanser","sensitive-skin-overnight-cream-fragrance-free","nourishing-facial-oil"]
    },
    hair: {
      flat: ["keratin-volume-boost-shampoo","keratin-volume-boost-conditioner","rosemary-hair-scalp-strengthening-oil"],
      damaged: ["keratin-intensive-rescue-hair-mask","keratin-shine-leave-in-hair-mist","keratin-volume-boost-conditioner","rosemary-hair-scalp-strengthening-oil"],
      scalp: ["sensitive-scalp-shampoo","rosemary-hair-scalp-strengthening-oil","keratin-volume-boost-conditioner"]
    },
    eyes: {
      tired: ["anti-fatigue-hydrogel-eye-patches","3-in-1-eye-cream-for-men"],
      eyelines: ["anti-age-hydrogel-eye-patches","peptide-anti-aging-serum"],
      everyday: ["3-in-1-eye-cream-for-men","anti-fatigue-hydrogel-eye-patches"]
    },
    body: {
      rough: ["icelandic-volcano-face-body-scrub","sensitive-skin-body-cream","sensitive-skin-face-body-cleanser"],
      fresh: ["aluminum-free-roll-on-deodorant","2-in-1-hair-body-wash-for-men","sensitive-skin-body-cream"]
    }
  };
  var NOTE = {
    dry: "Layer onto damp skin: toner, then serum, then cream.",
    dull: "Wash, treat, then hydrate. Give the dark-spot serum six weeks.",
    blemish: "Clear without stripping. Retinol alternative at night only.",
    lines: "Peptides in the morning, retinol alternative in the evening.",
    sensitive: "Fragrance-free throughout. Nothing that stings.",
    flat: "Wash, condition, then oil the scalp twice a week.",
    damaged: "Condition every wash. Mist the lengths, never the roots.",
    scalp: "Gentle wash first, then treat the scalp directly.",
    tired: "Patches when you need them, cream every day.",
    eyelines: "Patches twice a week, peptides underneath.",
    everyday: "One cream, morning and night.",
    rough: "Scrub twice a week, not more.",
    fresh: "Aluminium-free, so it works with your skin."
  };
  var answers = {};
  var steps = root.querySelectorAll(".lvq__step");
  var result = root.querySelector("[data-step=\"result\"]");
  var dots = root.querySelectorAll(".lvq__dot");
  var pool = root.querySelector(".lvq__data");
  function show(n) {
    for (var i = 0; i < steps.length; i++) { steps[i].classList.toggle("is-active", steps[i].getAttribute("data-step") === String(n)); }
    result.hidden = (n !== "result");
    var idx = (n === "result") ? 3 : parseInt(n, 10);
    for (var k = 0; k < dots.length; k++) { dots[k].classList.toggle("is-on", k < idx); }
  }
  function branch(area) {
    var g = root.querySelectorAll("[data-branch]");
    for (var i = 0; i < g.length; i++) { g[i].hidden = g[i].getAttribute("data-branch") !== area; }
  }
  function render() {
    var list = (MAP[answers.area] && MAP[answers.area][answers.need]) || [];
    if (answers.depth === "min") { list = list.slice(0, 2); }
    var box = root.querySelector("[data-cards]");
    box.innerHTML = "";
    for (var i = 0; i < list.length; i++) {
      var src = pool.querySelector("[data-handle=\"" + list[i] + "\"]");
      if (src) { box.appendChild(src.cloneNode(true)); }
    }
    root.querySelector("[data-rnote]").textContent = NOTE[answers.need] || "";
    show("result");
  }
  root.addEventListener("click", function (e) {
    var opt = e.target.closest(".lvq__opt");
    if (opt) {
      var key = opt.getAttribute("data-key");
      answers[key] = opt.getAttribute("data-val");
      var sibs = opt.parentElement.querySelectorAll(".lvq__opt");
      for (var i = 0; i < sibs.length; i++) { sibs[i].classList.remove("is-sel"); }
      opt.classList.add("is-sel");
      if (key === "area") { branch(answers.area); show(2); }
      else if (key === "need") { show(3); }
      else { render(); }
      return;
    }
    if (e.target.closest("[data-back]")) {
      var cur = e.target.closest(".lvq__step").getAttribute("data-step");
      show(cur === "3" ? 2 : 1);
      return;
    }
    if (e.target.closest("[data-restart]")) {
      answers = {};
      var sel = root.querySelectorAll(".lvq__opt.is-sel");
      for (var j = 0; j < sel.length; j++) { sel[j].classList.remove("is-sel"); }
      show(1);
    }
  });
})();
